import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { StoreModule } from '@ngrx/store';
import { reducers } from './store/root.reducer';
import { rootEffects } from './store/root.effects';
import { EffectsModule } from '@ngrx/effects';
import { ApiModule } from './api/api/api.module';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { DisplayPipesModule } from './pipes/display/display-pipes.module';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { QueryPipesModule } from './pipes/query/query-pipes.module';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { ModalsModule } from './modals/modals.module';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { CanActivateGuard } from './helpers/can-activate';

registerLocaleData(en);
import { PagesComponent } from './pages/pages.component';
import { WidgetsModule } from './components/widgets/widgets.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    EffectsModule.forRoot(rootEffects),
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }), //redux dev tool
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ApiModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzNotificationModule,
    NzModalModule,
    NzMessageModule,
    StoreDevtoolsModule.instrument({
      maxAge: 50, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    NzInputModule,
    NzSelectModule,
    NzIconModule,
    NzBadgeModule,
    NzButtonModule,
    NzGridModule,
    NzNotificationModule,
    NzDropDownModule,
    NzPopoverModule,
    NzImageModule,
    NzDividerModule,
    NzEmptyModule,
    DisplayPipesModule,
    NzAutocompleteModule,
    NzInputNumberModule,
    QueryPipesModule,
    NzBackTopModule,
    NzMessageModule,
    NzModalModule,
    NzDrawerModule,
    NzTreeSelectModule,
    ModalsModule,
    NzButtonModule,
    NzAffixModule,
    WidgetsModule,

  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US, },
    CanActivateGuard
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],

})
export class AppModule { }
